export class UserModel {

  constructor({email, id, is_active, role, nu_exams_profile = {}, application_id, application_email} = {}) {
    this.email = email;
    this.id = id;
    this.is_active = is_active;
    this.role = role;
    this.nu_exams_profile = nu_exams_profile;
    this.application_id = application_id;
    this.application_email = application_email;
  }

  getApiData() {
    return {
      email: this.email,
      id: this.id,
      is_active: this.is_active,
      role: this.role,
      nu_exams_profile: this.nu_exams_profile,
      application_id: this.application_id,
      application_email: this.application_email
    };
  }

}
